export default function () {
	const phones = document.querySelectorAll('[data-offer-phone-show]');
	const phoneModalEl = document.getElementById('js-offer-phone-modal');

	if (!(phoneModalEl instanceof HTMLElement)) {
		return;
	}

	const phoneModal = window.Modal.getOrCreateInstance(phoneModalEl);

	phones.forEach(function (phone) {
		phone.addEventListener('click', function (e) {
			var phone = '' + e.currentTarget.dataset.offerPhoneShow + '';

			phone = phone.replace(new RegExp('<b>i0</b>', 'g'), '');
			const m = phone.match(/^(\+?|00)?(\d{3})?\s*(\d{3})\s*(\d{3})\s*(\d{3})$/);
			if (m) {
				let p = '';
				if (m[1]) p += m[1];
				if (m[2]) p += m[2];
				if (m[3]) p += m[3];
				if (m[4]) p += m[4];
				if (m[5]) p += m[5];

				document.getElementById('js-offer-phone-number').innerHTML =
					'<a href="tel:' + p + '">' + phone + '</a>';
			} else {
				document.getElementById('js-offer-phone-number').innerText = phone;
			}

			phoneModal.show();

			$.ajax({ url: phoneModalEl.dataset.request + '&phone=' + encodeURIComponent(phone) });
		});
	});
}
